import { startTransition, useEffect, useState } from 'react';

const MOBILE_QUERY = '(max-width: 767px)';

export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia(MOBILE_QUERY);
    // The first render says false on every device (the bake cannot know the
    // viewport); on a phone this corrects it right after hydration, which
    // re-renders every consumer (the hero with its filters card, the info
    // section). As a transition that work is time-sliced instead of one long
    // task in front of the visitor's first tap (2026-10-02 phone profile).
    startTransition(() => setIsMobile(mq.matches));
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  return isMobile;
};
